import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  Icon,
  InputLabel,
  Menu,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import PropType from 'prop-types'
import QRCode from 'qrcode.react'
import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/Auth/AuthContext'
import { SocketContext } from '../../context/Socket/SocketContext'
import ButtonWithSpinner from '../ButtonWithSpinner'
import Dialog from '../Dialog'

import { get, has, isNil, isObject } from 'lodash'
import toastError from '../../errors/toastError'
import api from '../../services/api'

// const MessageSchema = Yup.object().shape({
// 	shortcode: Yup.string()
// 		.min(3, "Too Short!")
// 		.max(50, "Too Long!")
// 		.required("Required"),
//     message: Yup.string()
//         .min(3, "Too Short!")
//         .max(500, "Too Long!")
//         .required("Required")
// });

const useStyles = makeStyles(theme => ({
  root: {
    height: '600px',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '350px'
    }
  },
  list: {
    width: '100%',
    maxWidth: '350px',
    maxHeight: '200px',
    backgroundColor: theme.palette.background.paper
  },

  inline: {
    width: '100%'
  },

  qrcodeFrame: {
    padding: 12
  }
}))

const templateQueues = [
  'Personalizada',
  'Vendas',
  'Financeiro',
  'Suporte',
  'SAC',
  'Garantia'
]

function WizardDialog(props) {
  const classes = useStyles()

  const initialMessage = {
    id: null,
    shortcode: '',
    message: ''
  }

  const { modalOpen, onClose, messageSelected } = props
  const [dialogOpen, setDialogOpen] = useState(false)
  const [, setMessage] = useState(initialMessage)
  const [loading, setLoading] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const [queues, setQueues] = useState([])
  const [users, setUsers] = useState([])
  const [userQueues, setUserQueues] = useState([])
  const [userName, setUserName] = useState('')
  const [userMail, setUserMail] = useState('')
  const [userPsw, setUserPsw] = useState('')
  const [connectionName, setConnectionName] = useState('')
  const [queuesPopoverAnchor, setQueuesPopoverAnchor] = useState(null)
  const [userQueuesPopoverAnchor, setUserQueuesPopoverAnchor] = useState(null)
  const [nextEnabled, setNextEnabled] = useState(false)
  const [qrCode, setQrCode] = useState('')
  const [whatsappId, setWhatsappId] = useState(null)
  const [whatsapp, setWhatsapp] = useState(null)

  const steps = ['Departamento', 'Usuário', 'Conexão', 'QRCode', 'Concluído']

  const { user } = useContext(AuthContext)

  const socketManager = useContext(SocketContext)

  useEffect(() => {
    verifyAndSetMessage()
    setDialogOpen(modalOpen)
    if (modalOpen) {
      setActiveStep(0)
      setQueues([])
      setUsers([])
      setUserName('')
      setUserMail('')
      setUserPsw('')
      setConnectionName('')
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen])

  useEffect(() => {
    verifyAndSetMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageSelected])

  useEffect(() => {
    if (activeStep === 0) {
      setNextEnabled(queues.length > 0)
    } else if (activeStep === 1) {
      setNextEnabled(users.length > 0)
    }
  }, [activeStep, queues, users])

  useEffect(() => {
    if (whatsapp && whatsapp.status === 'qrcode') {
      setQrCode(whatsapp.qrcode)
    }
  }, [whatsapp])

  useEffect(() => {
    const socket = socketManager.GetSocket(user.companyId)

    const onWhatsappSession = data => {
      if (!whatsappId || data?.session?.id !== whatsappId) return

      if (data?.session?.status === 'DISCONNECTED') {
        toastError('Sessão desconectada')
        handleClose()
      }

      if (data?.session?.status === 'CONNECTED') {
        setActiveStep(4)
      }

      if (data.action === 'update') {
        setQrCode(data.session.qrcode)
        setWhatsapp(data.session)
      }
    }

    socket.on(`company-${user.companyId}-whatsappSession`, onWhatsappSession)
    socket.on('whatsappSession', onWhatsappSession)

    return () => {
      socket.disconnect()
    }
  }, [whatsappId, socketManager])

  const messageSelectedIsValid = () => {
    return (
      isObject(messageSelected) &&
      has(messageSelected, 'id') &&
      !isNil(get(messageSelected, 'id'))
    )
  }

  const verifyAndSetMessage = () => {
    if (messageSelectedIsValid()) {
      const { id, message, shortcode } = messageSelected
      setMessage({ id, message, shortcode })
    } else {
      setMessage(initialMessage)
    }
  }

  const handleClose = () => {
    onClose()
    setLoading(false)
  }

  // const handleSave = async (values) => {
  //     if (messageSelectedIsValid()) {
  //         editMessage({
  //             ...messageSelected,
  //             ...values,
  //             userId: user.id
  //         });
  //     } else {
  //         saveMessage({
  //             ...values,
  //             userId: user.id
  //         });
  //     }
  //     handleClose()
  // }

  const handleConnect = () => {
    setLoading(true)
    const payload = {
      queues,
      users,
      connectionName
    }

    api
      .post('/wizard', payload)
      .then(res => {
        setLoading(false)
        setActiveStep(activeStep + 1)
        setWhatsapp(res.data)
        setWhatsappId(res.data.id)
      })
      .catch(e => {
        setLoading(false)
        toastError(`Erro ao conectar: ${e?.message}`)
      })
  }

  /*
    stepper:
        1- fila
           - nome
           - mensagem de boas vindas
        2- usuário
           - nome
           - email
           - senha
        3- conexão
           - nome
        4- qrcode 
        5- concluído
    /* */
  useEffect(() => {
    if (activeStep === 1) {
      setUserQueues([])
    }
  }, [activeStep])

  const handleQueuesPopoverOpen = event => {
    setQueuesPopoverAnchor(event.currentTarget)
  }

  const handleUserQueuesPopoverOpen = event => {
    setUserQueuesPopoverAnchor(event.currentTarget)
  }

  const handleQueuesPopoverClose = () => {
    setQueuesPopoverAnchor(null)
  }

  const handleUserQueuesPopoverClose = () => {
    setUserQueuesPopoverAnchor(null)
  }

  const handleQueueChange = (e, index) => {
    const newQueues = [...queues]
    newQueues[index] = e.target.value
    setQueues(newQueues)
  }

  const addUser = () => {
    console.log(users)
    setUsers([
      ...users,
      {
        name: userName,
        email: userMail,
        password: userPsw,
        queues: [...userQueues]
      }
    ])
    setUserName('')
    setUserMail('')
    setUserPsw('')
    setUserQueues([])
  }

  return (
    <Dialog title="Wizard" modalOpen={dialogOpen} onClose={handleClose}>
      <DialogContent className={classes.root} dividers>
        <Grid direction="column" container>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === 0 && (
            <>
              {queues.length > 0 && (
                <>
                  <InputLabel>Departamentos</InputLabel>
                </>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={handleQueuesPopoverOpen}
              >
                Adicionar Departamentos
              </Button>
              {queues.map((queue, index) => (
                <FormControl key={index}>
                  <TextField
                    id="queue-name"
                    name="queueName"
                    value={queue}
                    onChange={e => {
                      handleQueueChange(e, index)
                    }}
                    InputProps={{
                      endAdornment: (
                        <Icon
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setQueues(queues.filter((_, i) => i !== index))
                          }}
                        >
                          <DeleteIcon />
                        </Icon>
                      )
                    }}
                  />
                </FormControl>
              ))}

              <Menu
                open={!!queuesPopoverAnchor}
                onClose={handleQueuesPopoverClose}
                anchorEl={queuesPopoverAnchor}
              >
                {templateQueues.map(
                  (queue, index) =>
                    !queues.includes(queue) && (
                      <MenuItem
                        key={index}
                        onClick={() => {
                          setQueues([...queues, queue])
                        }}
                      >
                        {queue}
                      </MenuItem>
                    )
                )}
              </Menu>
            </>
          )}

          {activeStep === 1 && (
            <>
              <FormControl>
                <TextField
                  id="user-name"
                  label="Nome do usuário"
                  name="userName"
                  value={userName}
                  onChange={e => {
                    setUserName(e.target.value)
                  }}
                />
              </FormControl>

              <FormControl>
                <TextField
                  id="user-mail"
                  label="Email do usuário"
                  name="userMail"
                  type="mail"
                  value={userMail}
                  onChange={e => {
                    setUserMail(e.target.value)
                  }}
                />
              </FormControl>

              <FormControl>
                <TextField
                  id="user-psw"
                  label="Senha do usuário"
                  name="userPsw"
                  type="password"
                  value={userPsw}
                  onChange={e => {
                    setUserPsw(e.target.value)
                  }}
                />
              </FormControl>

              <InputLabel>Departamentos</InputLabel>

              <Button
                variant="contained"
                color="primary"
                onClick={handleUserQueuesPopoverOpen}
              >
                Adicionar Departamentos
              </Button>

              {userQueues.map((queue, index) => (
                <FormControl key={index}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ width: '100%' }}>{queue}</span>
                    <Icon
                      style={{ cursor: 'pointer', marginLeft: '8px' }}
                      onClick={() => {
                        setUserQueues(userQueues.filter((_, i) => i !== index))
                      }}
                    >
                      <DeleteIcon />
                    </Icon>
                  </div>
                </FormControl>
              ))}

              <Menu
                open={!!userQueuesPopoverAnchor}
                onClose={handleUserQueuesPopoverClose}
                anchorEl={userQueuesPopoverAnchor}
              >
                {queues
                  .filter(queue => !userQueues.includes(queue))
                  .map((queue, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        setUserQueues([...userQueues, queue])
                      }}
                    >
                      {queue}
                    </MenuItem>
                  ))}
              </Menu>

              <Button
                variant="contained"
                color="primary"
                onClick={addUser}
                disabled={
                  !userName || !userMail || !userPsw || userQueues.length === 0
                }
              >
                Adicionar Usuário
              </Button>

              {users.length > 0 && (
                <>
                  <InputLabel>Usuários</InputLabel>
                  {users.map((user, index) => (
                    <FormControl key={index}>
                      <TextField
                        id="User-name"
                        name="userName"
                        value={user.name}
                        InputProps={{
                          endAdornment: (
                            <Icon
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setUsers(users.filter((_, i) => i !== index))
                              }}
                            >
                              <DeleteIcon />
                            </Icon>
                          )
                        }}
                      />
                    </FormControl>
                  ))}
                </>
              )}
            </>
          )}
          {activeStep === 2 && (
            <FormControl>
              <TextField
                id="Con-name"
                label="Nome da Conexão"
                name="conName"
                value={connectionName}
                onChange={e => {
                  setConnectionName(e.target.value)
                }}
              />
            </FormControl>
          )}

          {activeStep === 3 &&
            (!qrCode ? (
              <CircularProgress />
            ) : (
              <QRCode
                className={classes.qrcodeFrame}
                value={qrCode}
                size={256}
              />
            ))}

          {activeStep === 4 && <p>Conexão realizada com sucesso</p>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
        {activeStep > 0 && activeStep < 3 && (
          <Button
            onClick={() => setActiveStep(activeStep - 1)}
            color="primary"
            type="submit"
            autoFocus
          >
            Anterior
          </Button>
        )}
        {activeStep < 2 && (
          <Button
            onClick={() => setActiveStep(activeStep + 1)}
            color="primary"
            type="submit"
            autoFocus
            disabled={!nextEnabled}
          >
            Proximo
          </Button>
        )}
        {activeStep === 2 && (
          <ButtonWithSpinner
            onClick={() => handleConnect()}
            loading={loading}
            color="primary"
            type="submit"
            autoFocus
            disabled={!connectionName}
          >
            Conectar
          </ButtonWithSpinner>
        )}
      </DialogActions>
    </Dialog>
  )
}

WizardDialog.propType = {
  modalOpen: PropType.bool,
  onClose: PropType.func
}

export default WizardDialog
